<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LPTZWy/tc-custom/9783962726478.jpg?1703042695389" alt="This image is the cover for the book Hidden Treasures Or Why Some Succeed While Others Fail, Correct Times"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden Treasures Or Why Some Succeed While Others Fail, Correct Times
      </h1>
      <p class="bookDescription body article font2">
        <p>Some succeed while others fail. This is a recognised fact; yet history tells us that seven-tenths of our most successful men began life poor. As our title indicates, we shall endeavour to show "why some succeed while others fail. (Google)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry A. Lewis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f14f228e